import React from 'react';
import PropTypes from 'prop-types';
import { formatMoney, round10 } from '../../config/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './Results.css';

export function Results (props) {
  let maxDiffText = typeof props.maxDrawdownDifference === "undefined" || props.maxDrawdownDifference === 0
    ? `, with the same max drawdown size as your traditional portfolio`
    : `, with a max drawdown size of ${round10(Math.abs(props.maxDrawdownDifference), -2)}% ${props.maxDrawdownDifference < 0 ? "more" : "less"} than your traditional portfolio`;
  return props.hasStats ? (
    <div id="results-wrapper">
      <p>
        Since {props.startingDate.format("MMMM DD, YYYY")}, 
        if you allocated {props.bitcoinPercentage}% Bitcoin to your traditional portfolio{ props.withRebalancing ? " and rebalanced regularly" : "" }, 
        your portfolio would have returned {round10(props.totalReturnPercentageEnhanced - props.totalReturnPercentageTraditional, -2)}% more{maxDiffText}.
      </p>
      <div id="results-table">
        <div></div><div className="category">Traditional</div><div className="category">Enhanced</div>
        <div className="item-title">Total Return (Percentage)</div>
        <div>{round10(props.totalReturnPercentageTraditional, -2)}%</div>
        <div>{round10(props.totalReturnPercentageEnhanced, -2)}%</div>
        <div className="item-title">Total Return</div>
        <div>${formatMoney(props.totalReturnDollarsTraditional)}</div>
        <div>${formatMoney(props.totalReturnDollarsEnhanced)}</div>
        <div className="item-title">Annualized Return (Percentage)</div>
        <div>{round10(props.annualizedReturnPercentageTraditional, -2)}%</div>
        <div>{round10(props.annualizedReturnPercentageEnhanced, -2)}%</div>
        <div className="item-title">Annualized Return</div>
        <div>${formatMoney(props.annualizedReturnDollarsTraditional)}</div>
        <div>${formatMoney(props.annualizedReturnDollarsEnhanced)}</div>
        <div className="item-title">Sharpe Ratio</div>
        <div>{round10(props.sharpeTraditional, -3)}</div>
        <div>{round10(props.sharpeEnhanced, -3)}</div>
        <div className="item-title">Max Drawdown</div>
        <div>{round10(props.maxDrawDownTraditional, -2)}%</div>
        <div>{round10(props.maxDrawDownEnhanced, -2)}%</div>
      </div>
      <div id="share-box">
        <div>Share your results with your friends:</div>
        <div className="form-group">
          <input className="form-control" value={props.shareUrl} readOnly />
          <CopyToClipboard text={props.shareUrl}>
            <span className="copy-button"><FontAwesomeIcon icon={faCopy} /></span>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  ) : (<div id="results-wrapper" />);
}


// WEBPACK FOOTER //
// ./src/components/Results/Results.js